import React from "react";
import { Redirect, Route } from "react-router-dom";

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      props.match.params.key ? (
        <Redirect
          to={{
            pathname: "/data-insights",
            state: {
              token: props.match.params.token,
              key: props.match.params.key,
            },
          }}
        />
      ) : localStorage.getItem("token") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);
